module.exports = __webpack_public_path__ + "static/media/SmartShop_6-459w.9e3c7fdc.png";